module.exports = __webpack_public_path__ + "img/dutch_ideas.661552f5.jpg";